/**
 * @flow
 * @relayHash 63573663f8ab6c2a61673bc1aa9bcd6d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendPhoneVerificationInput = {|
  phone: string
|};
export type SendPhoneVerificationMutationVariables = {|
  input: SendPhoneVerificationInput
|};
export type SendPhoneVerificationMutationResponse = {|
  +sendPhoneVerification: {|
    +success: boolean
  |}
|};
export type SendPhoneVerificationMutation = {|
  variables: SendPhoneVerificationMutationVariables,
  response: SendPhoneVerificationMutationResponse,
|};
*/


/*
mutation SendPhoneVerificationMutation(
  $input: SendPhoneVerificationInput!
) {
  sendPhoneVerification(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendPhoneVerificationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sendPhoneVerification",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendPhoneVerificationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SendPhoneVerificationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SendPhoneVerificationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SendPhoneVerificationMutation",
    "id": null,
    "text": "mutation SendPhoneVerificationMutation(\n  $input: SendPhoneVerificationInput!\n) {\n  sendPhoneVerification(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd499564f0067da522771914bae012de2';
module.exports = node;
